import { motion } from "framer-motion";
import { Shield, Clock, TrendingUp, Users } from "lucide-react";

const stats = [
  {
    icon: <Users className="h-8 w-8" />,
    number: "500+",
    label: "PEOs Available",
    description: "Largest network of vetted PEOs"
  },
  {
    icon: <TrendingUp className="h-8 w-8" />,
    number: "85%",
    label: "Expect Growth",
    description: "PEO clients bullish about 2025"
  },
  {
    icon: <Users className="h-8 w-8" />,
    number: "200k+",
    label: "Organizations Use PEOs",
    description: "Organizations nationwide leveraging PEOs"
  },
  {
    icon: <Shield className="h-8 w-8" />,
    number: "4.5M+",
    label: "Jobs Supported",
    description: "Employment powered by PEO solutions"
  }
];

export const SocialProofSection = () => {
  return (
    <section className="py-16 bg-white border-y border-gray-100">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold mb-4">Discover the proven PEO advantage for your organization:</h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="flex justify-center mb-4 text-primary">
                {stat.icon}
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-sm font-semibold text-gray-700 mb-1">{stat.label}</div>
              <div className="text-xs text-gray-500">{stat.description}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};